// extracted by mini-css-extract-plugin
export default {"focusSplash":"CommonStyles_focusSplash__SwIbs","fadeInOut":"CommonStyles_fadeInOut__ubVHH"};